import type { ReactElement } from 'react';
import type { AttachmentUploadedProps } from '../types';
import { AttachmentIcon } from '../shared/icon';
import { Layout } from '../shared/layout';
import { Subtitle } from '../shared/subtitle';
import { Title } from '../shared/title';
import styles from './uploaded.module.css';

export function AttachmentUploaded({
  className,
  endContent,
  title,
  subtitle,
  icon,
  thumbnail,
  thumbnailAlt,
  fileUrl,
  onPreview,
  onRemove,
  ...props
}: AttachmentUploadedProps): ReactElement {
  return (
    <Layout
      className={className}
      data-testid="attachment-uploaded"
      endContent={endContent}
      icon={
        <AttachmentIcon
          fileUrl={fileUrl}
          icon={icon}
          onPreview={onPreview}
          thumbnail={thumbnail}
          thumbnailAlt={thumbnailAlt}
        />
      }
      onRemove={onRemove}
      {...props}
    >
      <Title onPreview={onPreview}>{title}</Title>
      <Subtitle className={styles.subtitle}>{subtitle}</Subtitle>
    </Layout>
  );
}
